import {OpenDayConfig} from "./OpenDayConfig";
import React from "react";

export function OpenDaySettingsTab() {


    return <OpenDayConfig />


}